import { render, staticRenderFns } from "./Decimalbox.vue?vue&type=template&id=3cbbef99&lang=pug"
import script from "./Decimalbox.vue?vue&type=script&lang=js"
export * from "./Decimalbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports